import { CmsArticleStatusesEnum } from '~/src/models/enums/cms.enum';
import { fallBackOrder } from '~/src/repositories/cms/constants/cms.constants';
import type { ProductsDictionaryKeyInterface } from '~/src/repositories/cms/types/cms.types';
import type { DictionaryInterface } from '~/src/repositories/cms/types/cms.sections.types';
import type { CmsMappedArticlesInterface } from '~/src/repositories/cms/types/cms.articles.types';
import type { ReferralProductInterface } from '~/src/models/types/referral-product.types';
import type { DirectoryRecordsInterface } from '~/src/repositories/cms/types/cms.directory.types';

export const getBooleanFromString = (value?: string) => value === 'true';

// TODO типизировать
export const getMappedDocumentationFilesData = (
    data: CmsMappedArticlesInterface | Record<string, never>,
): { documentationLink: string | null } | Record<string, never> => {
    if (data?.status === CmsArticleStatusesEnum.PUBLISHED) {
        const fileAttrs = data.attributeCategories?.file?.attributes;

        return {
            // @ts-ignore
            documentationLink: fileAttrs?.file?.value?.[0]?.url || null,
        };
    }
    return {};
};

export const getMappedProductGroup = (data: DirectoryRecordsInterface[] | []): string[] => {
    return data?.map((item) => {
        return item.value;
    });
};

export const getPermutationLeadData = (
    mappedLeadData: ProductsDictionaryKeyInterface,
    productGroupsArray: string[],
): ProductsDictionaryKeyInterface => {
    const data: ProductsDictionaryKeyInterface = {};
    for (const elem of productGroupsArray) {
        data[elem] = mappedLeadData[elem] || null;
    }
    return data;
};

export const getMappedLeadData = (data: DictionaryInterface[]): ProductsDictionaryKeyInterface => {
    const dataWithMainProps = data
        ?.filter((item) => item?.code === 'mts_products')
        .map((item) => {
            return item?.articles?.map((elem) => {
                if (elem?.status === CmsArticleStatusesEnum.PUBLISHED) {
                    return {
                        name: elem?.name || '',
                        order: elem?.order || fallBackOrder,
                        content: elem?.content || '',
                        code: elem?.attributeCategories?.product?.attributes?.product_code?.value || '',
                        group:
                            elem?.attributeCategories?.product?.attributes?.product_group?.value?.value ||
                            'Другие продукты',
                        addressRequired:
                            String(true) ===
                                elem?.attributeCategories?.product?.attributes?.obyazatelno_zapolneniye_adresa?.value ||
                            false,
                        urlAboutProduct:
                            elem?.attributeCategories?.product?.attributes?.url_about_product?.value || null,
                        id: elem?.id || null,
                        smallGroupImage: elem?.attributeCategories?.product?.attributes?.smallgroupimage?.value || null,
                    };
                }
            });
        })
        .sort(([item], [elem]) => (item?.order || fallBackOrder) - (elem?.order || fallBackOrder));

    const [dataWithMainPropsRested] = dataWithMainProps;

    return (
        dataWithMainPropsRested?.reduce((acc, current) => {
            acc[current?.group || ''] = acc[current?.group || ''] || [];
            acc[current?.group || ''].push(current);
            return acc;
        }, Object.create(null)) || {}
    );
};

export const getMappedReferralData = (
    data: CmsMappedArticlesInterface | Record<string, never>,
): ReferralProductInterface | Record<string, never> => {
    if (data?.status === CmsArticleStatusesEnum.PUBLISHED) {
        const technicalDescriptionAttrs = data.attributeCategories?.tekhnicheskoye_opisaniye?.attributes;
        const topBlockAttrs = data.attributeCategories?.verkhniy_blok?.attributes;
        const openGraphAttrs = data.attributeCategories?.otobrazheniye_ssylki_v_messendzherakh?.attributes;
        const blockWithRequestAttrs = data.attributeCategories?.blok_s_zayavkoy?.attributes;
        const documentsAttrs = data.attributeCategories?.dokumenty?.attributes;
        const addressIsRequired = technicalDescriptionAttrs?.obyazatelno_zapolneniye_adresa?.value;
        const displayProductGroup = data.attributeCategories?.otobrazheniye_v_gruppe_produktov?.attributes;

        return {
            productCode: technicalDescriptionAttrs?.productcode?.value || null,
            productName: topBlockAttrs?.productname?.value || null,
            bannerSubTitle: topBlockAttrs?.bannersubtitle?.value || null,
            bannerSubText: topBlockAttrs?.bannersubtext?.value || null,
            proposalSubText: blockWithRequestAttrs?.proposalsubtext?.value || null,
            bannerGradient: topBlockAttrs?.bannergradient?.value || null,
            bannerGradientBelow: topBlockAttrs?.bannergradientbelow?.value || null,
            bannerImage: topBlockAttrs?.bannerimage?.value || null,
            ogTitle: openGraphAttrs?.ogtitle?.value || null,
            ogDescription: openGraphAttrs?.ogdescription?.value || null,
            ogSiteName: openGraphAttrs?.ogsitename?.value || null,
            pageTitle: technicalDescriptionAttrs?.pagetitle?.value || null,
            content: data.content || null,
            documents: documentsAttrs?.documents || null,
            addressIsRequired: getBooleanFromString(addressIsRequired),
            leadCreation: technicalDescriptionAttrs?.leadcreaction?.value || null,
            referralUrl: technicalDescriptionAttrs?.referralurl?.value || null,
            productGroupName: displayProductGroup?.productgroup?.value?.value || null,
            productGroupCode: displayProductGroup?.productgroup?.value?.code || null,
            sefUrl: data?.sefUrl || null,
            agentId: technicalDescriptionAttrs?.agentid?.value?.code || null,
            agreement: blockWithRequestAttrs?.agreement?.value || null,
            promoIds: technicalDescriptionAttrs?.promoid?.value || null,
        };
    }
    return {};
};